import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tarjeta: {
    borderRadius: "12px",
    maxWidth: "100%",
    height: "350px",
    cursor: "pointer",
  },
  imagen: {
    width: "130px",
    maxWidth: "200px",
    minWidth: "100px",
    height: "130px",
  },
  contenedorImagen: {
    textAlign: "center",
    height: "130px",
  },
  contenedorTexto: {
    padding: "15px 10px 0px 10px",
  },
  descripcion: {
    whiteSpace: "pre-line",
  },
}));

/** Tarjeta de una opcion del modulo. Presentacion pura: no decide nada. */
const TarjetaOpcion = ({ opcion }) => {
  const { nombre, opciones, descripcion, imagen, color } = opcion;
  const classes = useStyles();

  return (
    <Card className={classes.tarjeta} elevation={1}>
      <CardHeader
        avatar={
          <Avatar aria-label="opcion" style={{ background: color }}>
            {nombre.charAt(0)}
          </Avatar>
        }
        title={nombre}
        subheader={opciones}
      />
      <CardContent>
        <Grid container direction="row" justifyContent="center">
          <Grid item xs={12} className={classes.contenedorImagen}>
            <img src={imagen} className={classes.imagen} alt={nombre} />
          </Grid>
          <Grid item xs={12} className={classes.contenedorTexto}>
            <Typography
              variant="body2"
              color="textSecondary"
              component="div"
              align="justify"
              className={classes.descripcion}
            >
              {descripcion}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

TarjetaOpcion.propTypes = {
  opcion: PropTypes.shape({
    nombre: PropTypes.string.isRequired,
    opciones: PropTypes.string,
    descripcion: PropTypes.string,
    imagen: PropTypes.string,
    color: PropTypes.string,
  }).isRequired,
};

export default TarjetaOpcion;
